import InactiveMobileUsers from './InactiveMobileUsers';

export default InactiveMobileUsers;
